var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.454,
    height: 33.454,
    viewBox: "0 0 33.454 33.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-11",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52553",
    "data-name": "Group 52553",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52551",
    "data-name": "Group 52551",
    transform: "translate(4.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52550",
    "data-name": "Group 52550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91071",
    "data-name": "Path 91071",
    d: "M78.869,8.78l-5.662,5.662h5.662Z",
    transform: "translate(-72.633 -8.206)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91072",
    "data-name": "Path 91072",
    d: "M72.651,11.884v8.71a4.014,4.014,0,0,0,4.01,4.01h11.31v5.91a.98.98,0,0,1-.98.98H70.2l2.322-2.863a2.78,2.78,0,0,0-1.788-4.507V20.366a2.785,2.785,0,0,0-2.782-2.782H64.419V8.2h7.216a.98.98,0,0,0,.98-.98V0H86.991a.98.98,0,0,1,.98.98V7.874H76.661a4.014,4.014,0,0,0-4.01,4.01Z",
    transform: "translate(-64.419 0)",
    fill: "#93a750"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_91073",
    "data-name": "Path 91073",
    d: "M277.091,219.352a.848.848,0,0,1-.851.821l-.8,0c0-.857,0-.523,0-1.647h.8A.848.848,0,0,1,277.091,219.352Z",
    transform: "translate(-257.443 -204.251)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91074",
    "data-name": "Path 91074",
    d: "M230.061,154.954h-.826c0,.642,0,1.579,0,1.954,0,.446,0,1.344,0,1.963.31,0,.655,0,.851-.008.985-.018,1.426-.991,1.426-1.949S231.135,154.954,230.061,154.954Zm0,0h-.826c0,.642,0,1.579,0,1.954,0,.446,0,1.344,0,1.963.31,0,.655,0,.851-.008.985-.018,1.426-.991,1.426-1.949S231.135,154.954,230.061,154.954Zm7.351-4.444H222.46a2.052,2.052,0,0,0-2.05,2.05v8.71a2.052,2.052,0,0,0,2.05,2.05h14.952a2.052,2.052,0,0,0,2.05-2.05v-8.71a2.052,2.052,0,0,0-2.05-2.05ZM224.806,157.9l-.8,0v1.62a.653.653,0,1,1-1.307,0V154.3a.654.654,0,0,1,.653-.653h1.456a2.129,2.129,0,1,1,0,4.257Zm5.309,2.265c-.422.007-1.477.012-1.522.012a.677.677,0,0,1-.666-.738V154.3a.653.653,0,0,1,.653-.655h1.481c1.653,0,2.765,1.313,2.765,3.267C232.825,158.773,231.685,160.142,230.116,160.17Zm6.238-3.958a.653.653,0,0,1,0,1.307h-1.3v2.01a.653.653,0,1,1-1.307,0V154.3a.654.654,0,0,1,.653-.653h2.119a.653.653,0,1,1,0,1.307h-1.466v1.257Zm-6.293-1.257h-.826c0,.642,0,1.579,0,1.954,0,.446,0,1.344,0,1.963.31,0,.655,0,.851-.008.985-.018,1.426-.991,1.426-1.949S231.135,154.954,230.061,154.954Z",
    transform: "translate(-206.008 -140.676)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52552",
    "data-name": "Group 52552",
    transform: "translate(0 19.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91075",
    "data-name": "Path 91075",
    d: "M10.79,306.971l-4.666,5.754a.822.822,0,0,1-1.276,0L.183,306.971a.821.821,0,0,1,.638-1.338H2.408V299.94a.821.821,0,0,1,.821-.821H7.744a.821.821,0,0,1,.821.821v5.693h1.588a.821.821,0,0,1,.638,1.338Z",
    transform: "translate(0 -299.119)",
    fill: "#93a750"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDFIcon.17519b92927be42ae0f56bdea6ab1879.svg";
export { ForwardRef as ReactComponent };